import {FC} from 'react'
import Form from 'react-bootstrap/Form'
interface FieldProductSpecProps {
  data: string
  type?: string
}
export const FieldProductSpec: FC<FieldProductSpecProps> = ({data, type}) => {
  if (type === 'editor') {
    return (
      <div
        className='h-100 fs-6 w-100'
        style={{
          backgroundColor: '#eff2f5',
          borderRadius: '0.425rem',
          border: '1px solid #e4e6ef',
          padding: '0.7rem 0.775rem',
          minHeight: '40px',
        }}
      >
        <span dangerouslySetInnerHTML={{__html: data}}></span>
      </div>
    )
  } else {
    return <Form.Control as='textarea' style={{height: '40px'}} value={data} disabled size='sm' />
  }
}

FieldProductSpec.defaultProps = {
  type: 'textarea',
}
